export default __webpack_public_path__ + "static/media/013-totem.c2a79a4e.svg";